<template>
      <b-nav-item-dropdown right no-caret>
        <template slot="button-content">
          <img :src="$auth.user()['info']['avatar']" class="img-avatar" :alt="$auth.user()['info']['name']">
        </template>
        <b-dropdown-header>{{$t('hello')}} {{$auth.user()['info']['name']}}</b-dropdown-header>
        <b-dropdown-item><i class="fa fa-user"></i> {{ $t('profile') }}</b-dropdown-item>
        <b-dropdown-item @click="logout()"><i class="fa fa-lock"></i> {{ $t('logout') }}</b-dropdown-item>
      </b-nav-item-dropdown>
</template>
<script>
  export default {
    name: 'header-dropdown-accnt',
    data: () => {
      return {}
    },
    methods: {
      logout: function () {
        this.$Progress.start()
        this.$auth.logout({
          makeRequest: true,
          success: function (response) {
            this.$Progress.finish()
            console.log(response)
          },
          error: function (error) {
            this.$Progress.fail()
            console.log(error)
          },
          redirect: '/login'
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Header/HeaderDropdownAccnt.vue